export const DEFAULT_CONTENT = {
  hero: {
    overline: "Motorcycle Club · Napoli · Est. 2019",
    title1: "NEAPOLIS",
    title2: "FREE CHAPTER",
    subtitle: "Bikes'n'Fun — Fondato a Napoli nel 2019",
    cta1: "Esplora lo Shop Merch",
    cta2: "Prossimi Giri",
  },
  marquee: {
    text: "FREE CHAPTER NAPOLI • EST. 2019 • BIKES 'N' FUN • VESUVIUS ROAD RIDERS • PASSIONE HARLEY & CUSTOM • NEAPOLIS MOTORCYCLE CLUB • ",
  },
  about: {
    overline: "Chi Siamo",
    title: "Liberi su due ruote, uniti dalla strada",
    text1: "Fondato nel 2019 a Napoli, all'ombra del Vesuvio, il Neapolis Free Chapter è sinonimo di amicizia incorruttibile, libertà su due ruote e puro divertimento. Niente burocrazia, niente vincoli: solo il rombo del bicilindrico e la fame di asfaltare nuove strade.",
    text2: "Dai lungomari di Pozzuoli alle curve della Costiera, ogni giro è una storia da raccontare attorno a una birra. Il Neapolis Free Chapter è aperto a chi condivide la passione per Harley, custom e per la strada che unisce fratelli.",
    stat1: "2019",
    stat2: "Napoli",
    stat3: "Bikes'n'Fun",
    stat4: "+150.000",
  },
  flag: {
    overline: "In Evidenza",
    title: "La bandiera non si ferma mai",
    description: "Due ruote, una bandiera e la strada davanti: così il Neapolis Free Chapter porta Napoli in ogni curva d'Italia.",
    image_url: "https://customer-assets-0z36b82j.emergentagent.net/job_neapolis-mc--8clzroy7/artifacts/8670ded7fb730532_836703918_2119319072056858_1522917546503661061_n.png.jpeg",
  },
  gallery: {
    overline: "Galleria Foto dei Giri",
    title: "Strada, mare e fratellanza",
    description: "I momenti che ci hanno fatto innamorare di ogni singolo chilometro.",
  },
  video: {
    overline: "Video dei Giri",
    title: "Il rombo del Neapolis Free Chapter in movimento",
    description: "I filmati dei raduni e dei giri: accendi l'audio e sali in sella con noi.",
  },
  events_section: {
    overline: "Prossimi Eventi & Raduni",
    title: "Metti benzina, al resto pensiamo noi",
    description: "Le uscite ufficiali del Neapolis Free Chapter: ritrovo, giro e birra finale.",
  },
  past: {
    overline: "Raduni Passati",
    title: "Le strade che abbiamo già bruciato",
    description: "I ricordi dei giri che hanno fatto la storia del Neapolis Free Chapter.",
  },
  direttivo: {
    overline: "Il Direttivo",
    title: "Chi guida il Neapolis Free Chapter",
    description: "I rappresentanti che portano avanti il Neapolis Free Chapter, giro dopo giro.",
  },
  merch: {
    overline: "Merchandising Ufficiale",
    title: "Porta addosso la nostra passione",
    description: "T-shirt, felpe, gilet e cappellini con lo stemma Neapolis. Ogni articolo supporta direttamente le attività del club.",
    notice: "Checkout dimostrativo attivo. L'integrazione con Stripe e PayPal per i pagamenti reali è in arrivo: gli ordini effettuati ora vengono registrati come richieste dimostrative, senza alcun addebito.",
  },
  membership: {
    overline: "Diventa Socio",
    title: "Pronto a viaggiare con noi?",
    description: "Compila la richiesta: arriverà direttamente al direttivo del Neapolis Free Chapter, che ti ricontatterà per conoscerti e presentarti il club.",
  },
  contacts: {
    overline: "Contatti & Clubhouse",
    title: "Vieni a trovarci o scrivici",
    description: "Vuoi unirti a un giro, conoscere il Neapolis Free Chapter o proporre un raduno? Il cancello della clubhouse è sempre aperto per chi ha la stessa passione.",
    city: "Napoli (NA), Italia",
    email: "info@neapolis-free-chapter.it",
    instagram: "@neapolisfreechapter",
    facebook: "Neapolis Free Chapter Naples",
  },
  footer: {
    tagline: "© 2019–2026 Neapolis Free Chapter · Napoli, Italia",
  },
};

export const SECTION_SCHEMA = [
  {
    key: "hero",
    label: "Apertura (Hero)",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title1", label: "Titolo riga 1", type: "input" },
      { name: "title2", label: "Titolo riga 2", type: "input" },
      { name: "subtitle", label: "Sottotitolo", type: "input" },
      { name: "cta1", label: "Pulsante principale", type: "input" },
      { name: "cta2", label: "Pulsante secondario", type: "input" },
    ],
  },
  {
    key: "marquee",
    label: "Scritta scorrevole",
    fields: [{ name: "text", label: "Testo del nastro", type: "textarea" }],
  },
  {
    key: "about",
    label: "Chi Siamo",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "text1", label: "Primo paragrafo", type: "textarea" },
      { name: "text2", label: "Secondo paragrafo", type: "textarea" },
      { name: "stat1", label: "Statistica 1 (Anno di Fondazione)", type: "input" },
      { name: "stat2", label: "Statistica 2 (Sede)", type: "input" },
      { name: "stat3", label: "Statistica 3 (Motto)", type: "input" },
      { name: "stat4", label: "Statistica 4 (Chilometri Percorsi)", type: "input" },
    ],
  },
  {
    key: "flag",
    label: "Foto in Evidenza",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
      { name: "image_url", label: "Foto", type: "image" },
    ],
  },
  {
    key: "gallery",
    label: "Galleria",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
    ],
  },
  {
    key: "video",
    label: "Video dei Giri",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
    ],
  },
  {
    key: "events_section",
    label: "Eventi",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
    ],
  },
  {
    key: "past",
    label: "Raduni Passati",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
    ],
  },
  {
    key: "direttivo",
    label: "Direttivo",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
    ],
  },
  {
    key: "merch",
    label: "Merch / Shop",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
      { name: "notice", label: "Avviso pagamenti demo", type: "textarea" },
    ],
  },
  {
    key: "membership",
    label: "Diventa Socio",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
    ],
  },
  {
    key: "contacts",
    label: "Contatti",
    fields: [
      { name: "overline", label: "Etichetta piccola", type: "input" },
      { name: "title", label: "Titolo", type: "input" },
      { name: "description", label: "Descrizione", type: "textarea" },
      { name: "city", label: "Clubhouse (città)", type: "input" },
      { name: "email", label: "Email pubblica", type: "input" },
      { name: "instagram", label: "Instagram", type: "input" },
      { name: "facebook", label: "Facebook", type: "input" },
    ],
  },
  {
    key: "footer",
    label: "Piè di pagina",
    fields: [{ name: "tagline", label: "Riga finale", type: "input" }],
  },
];
